<template>
    <div class="header-contentys pt-3 d-flex align-items-center">
        <div class="mr-5">
            <h4 class="text-primary font-weight-bold">Contrats ({{  lines }})</h4>
        </div>
        <div class="mr-4">
            <nav-rh></nav-rh>
        </div>
        <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
            <a href="" class="btn " @click.prevent="changeAffichage('list')" :class="{ 'active': affichage === 'list' }">
                <i class="fa-solid fa-bars"></i>
            </a>
            <a href="" class="btn " @click.prevent="changeAffichage('cards')" :class="{ 'active': affichage === 'cards' }">
                <i class="fa-solid fa-border-all"></i>
            </a>
        </div>
        <div class="px-1 d-flex mr-4">
            <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
                Ajouter un contrat <i class="fa-solid fa-plus"></i>
            </button>
        </div>
    </div>
    <hr>
    <div class="body-contentys ">
        <DataTableBackend
         :key="key" url="/api/contrats" :columns="columns" :affichage="affichage" :table="table" :idParams="this.$route.params.id" selection inCard v-on:set-total-records="updateLines">
            <template #action_group_btns=slotProps>
                <button type="button" class="btn btn-sm btn-danger mr-2" @click="deleteGroup(slotProps.data)">
                    <i class="fas fa-trash-alt"></i> Supprimer
                    <span v-if="isLoading == true" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>
            </template>
            <template #action_btns=slotProps>
                <button class="btn btn-sm btn-outline-dark" @click="openShowModal(slotProps.data)">
                    <i class="fa-solid fa-eye"></i>
                </button>
            </template>
        </DataTableBackend>
    </div>
</template>
  
<script >
import $ from "jquery"
import { defineComponent, defineAsyncComponent } from 'vue';
import NavRh from '../NavRh.vue'
const CreateContrat = defineAsyncComponent(() => import('./CreateContrat.vue'));
const ShowContrat = defineAsyncComponent(() => import('./ShowContrat.vue'));

export default defineComponent({
    components: { NavRh },
    name: 'IndexContrat',
    data() {
        return {
            lines: 0,
            key:1,
            table: "contrats",
            affichage: "list",
            columns: [
                {
                    key: 'date_debut',
                    label: 'Prise d\'effet',
                    format: 'date',
                    exportable: true
                },
                {
                    key: 'employe.pseudo',
                    label: 'Employé',
                    exportable: true
                },
                {
                    key: 'type',
                    label: 'Type',
                    exportable: true
                },
                {
                    key: 'duree',
                    label: 'Durée (mois)',
                    exportable: true
                },
                {
                    key: 'salaire',
                    label: 'Salaire',
                    format: 'money',
                    exportable: true
                },
                {
                    key: 'statut',
                    label: 'Etat',
                    format: 'state',
                    exportable: true
                }
            ]
        };
    },
    methods: {
        changeAffichage(type) {
            this.affichage = type;
             this.key++
        },
        getPermission(permission) {
            return this.$store.getters.permissions.includes(permission)
        },
        openShowModal(objData) {
            this.$dialog.open(ShowContrat, {
                props: {
                    header: "Contrat ID" + objData.id,
                    style: {
                        width: '30vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        openCreateModal() {
            this.$dialog.open(CreateContrat, {
                props: {
                    header: "Nouveau contrat",
                    style: {
                        width: '30vw'
                    },
                    modal: true
                }
            });
        },
        deleteGroup(selection) {
            if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
                return
            }

            this.isLoading = true
            let selectedLines = []
            for (let index = 0; index < selection.length; index++) {
                const element = selection[index];
                selectedLines.push(element.id)
            }

            this.axios.post('/api/contrats/destroy-group', { selected_lines: selectedLines }).then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    for (let index = 0; index < response.data.message.length; index++) {
                        const element = response.data.message[index];
                        this.$toast.add({
                            severity: element.severity,
                            detail: element.value,
                            life: parseInt(5000 * (index + 1))
                        });
                    }
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        }
    }
});
</script>